export const checkOverflow = (
  textContainer: HTMLDivElement | null
): boolean => {
  if (textContainer)
    return (
      textContainer.offsetHeight < textContainer.scrollHeight ||
      textContainer.offsetWidth < textContainer.scrollWidth
    );
  return false;
};
